import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import { ProtectedRoute } from "@/components/ProtectedRoute";
import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import AuthCallback from "@/pages/AuthCallback";
import Marks from "@/pages/Marks";
import Courses from "@/pages/Courses";
import Apply from "@/pages/Apply";
import ApplyBatch from "@/pages/ApplyBatch";
import Applications from "@/pages/Applications";
import PaymentCallback from "@/pages/PaymentCallback";
import Admin from "@/pages/Admin";
import Influencer from "@/pages/Influencer";
import TrackSelect from "@/pages/TrackSelect";
import Nsfas from "@/pages/Nsfas";
import Colleges from "@/pages/Colleges";
import Study from "@/pages/Study";
import ApplyCollege from "@/pages/ApplyCollege";
import AiHelp from "@/pages/AiHelp";
import Partner from "@/pages/Partner";
import Terms from "@/pages/Terms";
import Privacy from "@/pages/Privacy";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import { ResourcesIndex, ArticlePage } from "@/pages/Resources";
import { About, HowItWorks, Services, Contact, Faq, CookiePolicy, Disclaimer } from "@/pages/InfoPages";

function AppRouter() {
  const location = useLocation();
  // Google OAuth returns to {origin}/dashboard/marks#session_id=... — process it first.
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/login" element={<Login />} />
      <Route path="/register" element={<Register />} />
      <Route path="/terms" element={<Terms />} />
      <Route path="/privacy" element={<Privacy />} />
      <Route path="/about" element={<About />} />
      <Route path="/how-it-works" element={<HowItWorks />} />
      <Route path="/services" element={<Services />} />
      <Route path="/contact" element={<Contact />} />
      <Route path="/faq" element={<Faq />} />
      <Route path="/cookie-policy" element={<CookiePolicy />} />
      <Route path="/disclaimer" element={<Disclaimer />} />
      <Route path="/resources" element={<ResourcesIndex />} />
      <Route path="/resources/:slug" element={<ArticlePage />} />
      <Route path="/forgot-password" element={<ForgotPassword />} />
      <Route path="/reset-password" element={<ResetPassword />} />
      <Route path="/payment/callback" element={<PaymentCallback />} />
      <Route path="/dashboard/marks" element={<ProtectedRoute><Marks /></ProtectedRoute>} />
      <Route path="/dashboard/courses" element={<ProtectedRoute><Courses /></ProtectedRoute>} />
      <Route path="/dashboard/apply/:university" element={<ProtectedRoute><Apply /></ProtectedRoute>} />
      <Route path="/dashboard/apply-batch" element={<ProtectedRoute><ApplyBatch /></ProtectedRoute>} />
      <Route path="/dashboard/applications" element={<ProtectedRoute><Applications /></ProtectedRoute>} />
      <Route path="/dashboard/admin" element={<ProtectedRoute><Admin /></ProtectedRoute>} />
      <Route path="/dashboard/influencer" element={<ProtectedRoute><Influencer /></ProtectedRoute>} />
      <Route path="/dashboard/track" element={<ProtectedRoute><TrackSelect /></ProtectedRoute>} />
      <Route path="/dashboard/nsfas" element={<ProtectedRoute><Nsfas /></ProtectedRoute>} />
      <Route path="/dashboard/colleges" element={<ProtectedRoute><Colleges /></ProtectedRoute>} />
      <Route path="/dashboard/study" element={<ProtectedRoute><Study /></ProtectedRoute>} />
      <Route path="/dashboard/apply-college" element={<ProtectedRoute><ApplyCollege /></ProtectedRoute>} />
      <Route path="/dashboard/help" element={<ProtectedRoute><AiHelp /></ProtectedRoute>} />
      <Route path="/dashboard/partner" element={<ProtectedRoute><Partner /></ProtectedRoute>} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Toaster position="top-center" offset={76} richColors />
          <AppRouter />
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
